<script lang="ts">
import ChevronDownIcon from "@lucide/svelte/icons/chevron-down";
import ChevronUpIcon from "@lucide/svelte/icons/chevron-up";
import type { PoiCategory } from "../../lib/search/categories.ts";
import { SEARCH_ICONS } from "../../lib/search/searchIcons.ts";
import * as Command from "../ui/command/index.ts";

let {
  categories,
  expanded,
  oncategoryselect,
  ontoggleexpanded,
}: {
  categories: readonly PoiCategory[];
  expanded: boolean;
  oncategoryselect: (category: PoiCategory) => void;
  ontoggleexpanded: () => void;
} = $props();
</script>

<Command.Group class="p-4">
  <div class="grid grid-cols-2 gap-3">
    {#each categories as category}
      <Command.Item
        value={`featured-category-${category.id}`}
        onSelect={() => oncategoryselect(category)}
        class="h-auto min-h-9 justify-start rounded-full border px-0 py-0 shadow-xs"
      >
        {@const CategoryIcon = SEARCH_ICONS[category.icon]}
        <div class="flex w-full flex-row items-center gap-2 py-0.5 pl-2 pr-3 whitespace-normal">
          <span
            class="flex size-8 shrink-0 items-center justify-center"
            aria-hidden="true"
          >
            <CategoryIcon class="size-4" />
          </span>
          <span class="flex-1 text-center">{category.label}</span>
        </div>
      </Command.Item>
    {/each}
    <Command.Item
      value={expanded ? "featured-show-less" : "featured-show-more"}
      onSelect={ontoggleexpanded}
      class="h-auto min-h-9 justify-start rounded-full border px-0 py-0 shadow-xs"
    >
      <div class="flex w-full flex-row items-center gap-2 py-0.5 pl-2 pr-3 whitespace-normal">
        <span
          class="flex size-8 shrink-0 items-center justify-center"
          aria-hidden="true"
        >
          {#if expanded}
            <ChevronUpIcon class="size-4" />
          {:else}
            <ChevronDownIcon class="size-4" />
          {/if}
        </span>
        <span class="flex-1 text-center">
          {expanded ? "Show less" : "Show more"}
        </span>
      </div>
    </Command.Item>
  </div>
</Command.Group>
